<template>
  <div
    ref="calculatorContainer"
    class="calculator calculator_small calc"
    :class="{ 'calculator_padding': activeStep === 1, 'calc_import': calcImport }"
    data-type="clients"
  >
    <div
      id="calculator"
      class="anchor anchor-calculator"
      style="margin-top: -207px; padding-top: 207px;"
    />
    <b-form
      ref="calculatorPip"
      type="calculator-pip"
      novalidate
      name="calculator_pip"
      :class="{ 'form-error': $v.$error }"
      enctype="application/x-www-form-urlencoded | multipart/form-data | text/plain"
      @submit.prevent="someAction"
    >
      <div class="calculator__head">
        <div
          class="calculator__title calculator__title_active calculator__title_big"
          :class="{ 'd-block': luggageDelivery }"
        >
          <template v-if="luggageDelivery && (activeStep === 1 || activeStep === 2)">
            Калькулятор расчета <strong class="color-red">стоимости отправки багажа</strong>
          </template>
          <template v-else>
            {{ stepTitle }}
          </template>
        </div>
        <div
          v-if="(hideMenu || (activeStep !== 1 && activeStep !== 2))"
          class="calc__steps-wrap"
          :class="{'calc__steps-wrap_full': activeStep === 6 || activeStep === 7 || activeStep === 'pay-customs'}"
        >
          <ul
            class="calc__steps"
            :class="{'calc__steps_full': activeStep === 6 || activeStep === 7}"
          >
            <li
              class="calc__step"
              :class="[{'calc__step_active': getStep === 1}]"
              @click="() => onCalcStepClick(1)"
            />
            <li
              class="calc__step"
              :class="[{'calc__step_active': getStep === 2}]"
              @click="() => onCalcStepClick(2)"
            />
            <li
              class="calc__step"
              :class="[{'calc__step_active': getStep === 3}]"
              @click="() => onCalcStepClick(3)"
            />
            <li
              class="calc__step"
              :class="[{'calc__step_active': getStep === 4}]"
              @click="() => onCalcStepClick(4)"
            />
            <li
              class="calc__step"
              :class="[{'calc__step_active': getStep === 5}]"
              @click="() => onCalcStepClick(5)"
            />
          </ul>
          <div class="calc__steps__text">
            шаг {{ getStep }}/5
          </div>
        </div>
        <ul
          v-if="(!hideMenu && (activeStep === 1 || activeStep === 2)) && !luggageDelivery"
          class="nav"
          :class="{'nav_border-short': !isMobile }"
          style="max-width: 406px;"
        >
          <li>
            <a
              href="/#calculator"
              class="nav__item active"
            >
              <span>Частным лицам</span>
            </a>
          </li>
          <li>
            <a
              :href="hrefIM"
              class="nav__item"
            >
              <span>Интернет-магазинам</span>
            </a>
          </li>
        </ul>
      </div>
      <CalcComment
        v-if="!hideCourierWarning && russianWarning"
        class="calculator__warning"
      >
        <div>
          Вызовите курьера на удобный для вас адрес и передайте ему посылку.
          Инструкция по курьерскому забору <a class="calc-link-blue" href="https://boxberry.ru/vyzov-kur-era" target="_blank" rel="noopener">здесь.</a>
        </div>
      </CalcComment>
      <CalcComment
        v-if="showWarningVisa && !isDirectionKzKz"
        class="calculator__warning"
      >
        <template #title>
          Уважаемые клиенты,
        </template>
        вы&nbsp;можете оплатить заказ без ограничений по&nbsp;сумме картами выпущенными в&nbsp;РФ и&nbsp;картами Mastercard.
        Банковскими картами Visa, выпущенными за&nbsp;рубежом, возможно оплатить заказ только от&nbsp;1100&nbsp;рублей.
        Также услугу можно оформить с&nbsp;оплатой получателем при вручении посылки без ограничений по&nbsp;сумме
      </CalcComment>
      <CalcComment
        v-else-if="showWarningArmenia"
        class="calculator__warning"
      >
        <template #title>
          Уважаемые клиенты,
        </template>
        сейчас невозможно оплатить сумму ниже 1100&nbsp;р. зарубежной картой.
        Такую доставку можно оплатить картой, выпущенной российскими банками или выбрать опцию оплата получателем.
        Приносим извинения за&nbsp;неудобства.
      </CalcComment>
      <CalcCommentError
        v-if="((activeStep === 6 && calcImport && !receiverPayImport) || activeStep === 'pay-customs2' || activeStep === 'pay-customs') && !isDirectionKzKz"
        class="calculator__warning"
      >
        Пожалуйста проверьте данные получателя и&nbsp;отправителя.
        При отправлении в&nbsp;другую страну, опечатка в&nbsp;ФИО может стать причиной отказа в&nbsp;доставке/выдаче посылки.
      </CalcCommentError>
      <CalcComment
        v-if="activeStep === 'form-customs'"
        class="calculator__warning"
      >
        <template #title>
          Внимание!
        </template>
        <ul class="calculator-form-customs__warning__ul">
          <li class="calculator-form-customs__warning__li">
            Пожалуйста, указывайте полное и корректное описание вложения.
          </li>
          <li class="calculator-form-customs__warning__li">
            Фактическое количество и сами вложения должны совпадать с тем, что вы указали в описании.
          </li>
          <li class="calculator-form-customs__warning__li">
            Пожалуйста, указывайте корректную стоимость. Таможенные службы могут попросить у вас или у получателя подтверждение заявленной стоимости.
          </li>
          <li class="calculator-form-customs__warning__li">
            Пожалуйста, проверьте не попадает ли ваше отправление в
            <a
              class="calculator-form-customs__warning__link"
              href="https://boxberry.ru/castnym-klientam/info-klientam/dokumenty"
              target="_blank"
              rel="noopener"
            >
              список запрещенных к экспорту товаров
            </a>
          </li>
          <li class="calculator-form-customs__warning__li">
            Выполнение этих правил позволит успешно и быстро пройти таможенное оформление в России и стране получателя.
          </li>
        </ul>
      </CalcComment>
      <CalcComment
        v-if="activeStep === 5 && isCustoms"
        class="calculator__warning"
        :icon-info="true"
        :item-center="true"
      >
        Все поля обязательны для заполнения.
        Во&nbsp;избежание проблем с&nbsp;таможнями и&nbsp;почтовыми службами пожалуйста,
        указывайте полные и&nbsp;правильные данные.
      </CalcComment>
      <div class="calc__content">
        <div
          v-if="activeStep === 1 || activeStep === 2"
          class="calc__row"
        >
          <div class="calc__col calc__col-left">
            <CalculatorPIP1stStepView
              ref="calculatorPip1stStep"
              :order-p-i-p="orderPIP"
              :order-calc-p-i-p="orderCalcPIP"
              :is-restarted="isRestarted"
              :package-submit="packageSubmit"
              :is-loading="isLoading"
              :absolute-url="absoluteUrl"
              :is-valid="isValid"
              :error-dictionary="errorDictionary"
              :price-is-fine="priceIsFine"
              :max-price="maxPrice"
              :acceptable-counties-from="acceptableCountiesFrom"
              :acceptable-counties-to="acceptableCountiesTo"
              :country-from-default="countryFromDefault"
              :country-to-default="countryToDefault"
              :box-size-is-correct="boxSizeIsCorrect"
              :box-size-any-is-correct="boxSizeAnyIsCorrect"
              :box-size-sum-is-correct="boxSizeSumIsCorrect"
              :box-size-is-zero="boxSizeIsZero"
              :sale-pip="salePip"
              :calc-import="calcImport"
              :weight-is-fine="weightIsFine"
              :weight-is-small="weightIsSmall"
              :min-price="minPriceResult"
              :is-direction-kz-kz="isDirectionKzKz"
              :is-sender-belarus="isSenderBelarus"
              :box-size-min-error-belarus="boxSizeMinErrorBelarus"
              @step-up="onFirstStepUp"
              @error="onShowModalError"
              @resetFields4thStep="resetReceiverFields"
              @changePointForm="() => setNeedChangePointFrom(true)"
              @changePointTo="() => setNeedChangePointTo(true)"
              @changeIsLoading="isLoading = $event"
            />
            <CalculatorPIP2ndStepView
              ref="calculatorPip2ndStep"
              :order-p-i-p="orderPIP"
              :order-calc-p-i-p="orderCalcPIP"
              :is-loading="isLoading"
              :initial-delivery-options="initialDeliveryOptions"
              :default-delivery-type="defaultDeliveryType"
              :validations="$v"
              :kladr="kladr"
              :list-services="list_services"
              :is-valid="isValid"
              :error-dictionary="errorDictionary"
              :sale-pip="salePip"
              :hide-promocode-option="hidePromocodeOption"
              :calc-import="calcImport"
              :cbr-daily="cbrDaily"
              :hide-services="hideServices"
              :is-customs="isCustoms"
              :is-direction-kz-kz="isDirectionKzKz"
              @step-back="onStepBack"
              @step-up="onSecondStepUp"
              @error="onShowModalError"
              @changeTotalPrice="onChangeTotalPrice"
              @changeCheckDeliveryMethod="onChangeCheckDeliveryMethod"
              @changePromocodeSubmitted="promocodeSubmitted = $event"
              @changeTotalPriceImport="totalPriceImport = $event"
            />
          </div>
          <div
            v-if="!isMobile"
            class="calc__col calc__col_right"
          >
            <CalcTotal
              :calc-import="calcImport"
              :order-p-i-p="orderPIP"
              :order-calc-p-i-p="orderCalcPIP"
              :promocode-submitted="promocodeSubmitted"
              :check-delivery-method="checkDeliveryMethod"
              :total-price="totalPrice"
              :total-price-import="totalPriceImport"
              :is-valid="isValid"
              :is-loading="isLoading"
              :cbr-daily="cbrDaily"
              :is-direction-kz-kz="isDirectionKzKz"
              @next="onBtnNextClick"
            />
          </div>
        </div>

        <CalculatorFormCustomsView
          v-if="activeStep === 'form-customs'"
          :items="items"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :validations="this.$v"
          :error-dictionary="errorDictionary"
          :is-customs="isCustoms"
          :calc-import="calcImport"
          :receiver-pay-import="receiverPayImport"
          @changeItems="items = $event"
          @step-up="onFormCustomsStepUp"
          @step-back="onStepBack"
        />
        <CalculatorPIP3rd4thStepView
          v-if="activeStep === 3"
          key="calculatorPip3ndStep"
          ref="calculatorPip3ndStep"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :is-loading="isLoading"
          :points-collection="senderPointsCollection"
          :points-collection-return="senderPointsCollection"
          :validations="$v"
          :kladr="kladr"
          :address-valid="addressValid.sender"
          :need-reset-receiver-fields="needResetReceiverFields"
          :need-change-point="needChangePointFrom"
          :validation-target="$v.orderPIP.sender"
          :order-p-i-p-target="orderPIP.sender"
          :order-calc-p-i-p-target="orderCalcPIP.sender"
          person="sender"
          @resetReceiverFieldsSuccess="needResetReceiverFields = false"
          @someAction="someAction"
          @step-back="onStepBack"
          @step-up="onThirdStepUp"
          @changedCity="() => setNeedChangePointFrom(false)"
        />
        <CalculatorPIP3rd4thStepView
          v-if="activeStep === 4"
          key="calculatorPip4ndStep"
          ref="calculatorPip4ndStep"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :is-loading="isLoading"
          :points-collection="receiverPointsCollection"
          :points-collection-return="senderPointsCollection"
          :validations="$v"
          :kladr="kladr"
          :address-valid="addressValid.receiver"
          :need-reset-receiver-fields="needResetReceiverFields"
          :need-change-point="needChangePointTo"
          :validation-target="$v.orderPIP.receiver"
          :order-p-i-p-target="orderPIP.receiver"
          :order-calc-p-i-p-target="orderCalcPIP.receiver"
          :accept-receiver-payments="acceptReceiverPayments"
          person="receiver"
          @resetReceiverFieldsSuccess="needResetReceiverFields = false"
          @someAction="someAction"
          @step-back="onStepBack"
          @step-up="onFourthStepUp"
          @changedCity="() => setNeedChangePointTo(false)"
          @changedReceiverPoints="onChangedReceiverPoints"
          @changedAcceptReceiverPayments="onChangedAcceptReceiverPayments"
        />
        <CalculatorPIP5thStepView
          v-if="activeStep === 5"
          ref="CalculatorPip5thStepView"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :validations="this.$v"
          :order_num="order_num"
          :error-dictionary="errorDictionary"
          :sale-pip="salePip"
          :calc-import="calcImport"
          :total-price="totalPrice"
          :hide-form-email="hideFormEmail"
          :receiver-can-pay="receiverCanPay"
          :receiver-pay-import="receiverPayImport"
          :is-customs="isCustoms"
          :personal-agreement-link="personalAgreementLink"
          @someAction="someAction"
          @step-back="onStepBack"
          @step-up="onFifthStepUp"
          @error="onShowModalError"
          @step-up-import="onFifthStepUpImport"
          @step-up-customs="onFifthStepUpCustoms"
        />
        <CalculatorPIPPayCustomsView
          v-if="activeStep === 'pay-customs'"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :check-delivery-method="checkDeliveryMethod"
          :validations="this.$v"
          :total-price="totalPrice"
          :total-price-import="totalPriceImport"
          :cbr-daily="cbrDaily"
          :order-num="order_num"
          :payment-id="paymentId"
          :error-dictionary="errorDictionary"
          :absolute-url="absoluteUrl"
          :hide-services="hideServices"
          :personal-agreement-link="personalAgreementLink"
          :calc-import="calcImport"
          :promocode-submitted="promocodeSubmitted"
          :items="items"
          :sale-pip="salePip"
          :is-direction-kz-kz="isDirectionKzKz"
          @error="onShowModalError"
          @step-back="onStepBack"
          @step-up="onPayCustomsStepUp"
        />

        <CalculatorPIPPayStepView
          v-if="(activeStep === 6 && calcImport && !receiverPayImport) || activeStep === 'pay-customs2'"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :check-delivery-method="checkDeliveryMethod"
          :validations="this.$v"
          :total-price="totalPrice"
          :cbr-daily="cbrDaily"
          :order-num="order_num"
          :payment-id="paymentId"
          :error-dictionary="errorDictionary"
          :absolute-url="absoluteUrl"
          :hide-services="hideServices"
          :personal-agreement-link="personalAgreementLink"
          :calc-import="calcImport"
          :is-direction-kz-kz="isDirectionKzKz"
          @error="onShowModalError"
          @step-back="onStepBack"
          @step-up="onPayStepUp"
        />
        <CalculatorPIP6thStepView
          v-if="(activeStep === 6 && (!calcImport || receiverPayImport)) || activeStep === 7"
          :order-p-i-p="orderPIP"
          :order-calc-p-i-p="orderCalcPIP"
          :is-loading="isLoading"
          :sender-points-collection="senderPointsCollection"
          :order_num="order_num"
          :validations="this.$v"
          :email-payment="emailPayment"
          :order="order"
          :error-dictionary="errorDictionary"
          :sender-point-payment="senderPointPayment"
          :result-page="resultPage"
          @someAction="someAction"
          @restart="onRestart"
          @error="onShowModalError"
          @change-email="onChangeEmail"
        />
      </div>
    </b-form>
    <CalculatorModalError
      v-if="error.modalShow"
      :message="error.messageError"
      @modal_error_close="onCloseModalError"
    />
    <CalculatorModalWarning
      v-if="warning.modalShow"
      :title="warning.titleWarning"
      :message-text="warning.messageWarning"
      :btn-text="warning.btnWarning"
      @modal_warning_close="onCloseModalWarning"
    />
    <CalcFixedMobile
      v-if="isMobile && showCalcFixed && (activeStep === 1 || activeStep === 2)"
      :calc-import="calcImport"
      :order-p-i-p="orderPIP"
      :order-calc-p-i-p="orderCalcPIP"
      :promocode-submitted="promocodeSubmitted"
      :check-delivery-method="checkDeliveryMethod"
      :total-price="totalPrice"
      :total-price-import="totalPriceImport"
      :is-valid="isValid"
      :is-loading="isLoading"
      :cbr-daily="cbrDaily"
      :is-direction-kz-kz="isDirectionKzKz"
      :calc-changed="calcChanged"
      @next="onBtnNextClick"
    />
  </div>
</template>

<script>
/* global ym, $, apiUrl */
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import {
  sameAs, required, minLength,
} from 'vuelidate/lib/validators';

import { VueMaskDirective } from 'v-mask';
import deviceInfo from '../../helpers/device';
import CalcComment from './components/CalcComment.vue';
import CalculatorModalError from './CalculatorModalError.vue';

import CalculatorPIP1stStepView from './CalculatorPIP1stStepView.vue';
import CalculatorPIP2ndStepView from './CalculatorPIP2ndStepView.vue';
import CalculatorPIP3rd4thStepView from './CalculatorPIP3rd4thStepView.vue';
import CalculatorPIP5thStepView from './CalculatorPIP5thStepView.vue';
import CalculatorPIP6thStepView from './CalculatorPIP6thStepView.vue';
import CalculatorModalWarning from './CalculatorModalWarning.vue';
import CalculatorPIPPayStepView from './CalculatorPIPPayStepView.vue';

import {
  CALC_PIP,
  CITIES_CODES,
  COUNTRY_CODES,
  PACKAGE_TYPE,
} from '../../helpers/constans';
import { actions as cityRepositoryActions, getters as cityRepositoryGetters } from '../../store/city.repository';
import CalculatorFormCustomsView from './customs/CalculatorFormCustomsView.vue';
import CalculatorPIPPayCustomsView from './customs/CalculatorPIPPayCustomsView.vue';
import CalcTotal from './components/CalcTotal.vue';
import CalcFixedMobile from './components/CalcFixedMobile.vue';
import CalcCommentError from './components/CalcCommentError.vue';

const axios = require('axios');
const replaceAll = require('string.prototype.replaceall');

const NEW_API_URL = apiUrl;

Vue.use(Vuelidate);
Vue.directive('mask', VueMaskDirective);

const errorDictionary = {
  public_price: 'Оценочная стоимость',
  delivery_type: 'Тип доставки',
  'sender.point': 'Отделение отправителя',
  'receiver.point': 'Отделение получателя',
  package: '',
  senderCity: 'Город отправителя',
  receiverCity: 'Город получателя',
  publicPrice: '',
  'package.depth': 'Длина',
  'package.height': 'Высота',
  'package.width': 'Ширина',
  weight: '',
};

export default {
  errorDictionary,
  name: 'CalculatorPIPView',
  components: {
    CalcCommentError,
    CalcFixedMobile,
    CalcTotal,
    CalcComment,
    CalculatorPIPPayCustomsView,
    CalculatorFormCustomsView,
    CalculatorModalWarning,
    CalculatorPIP1stStepView,
    CalculatorPIP2ndStepView,
    CalculatorPIP3rd4thStepView,
    CalculatorPIP5thStepView,
    CalculatorPIP6thStepView,
    CalculatorModalError,
    CalculatorPIPPayStepView,
  },
  props: {
    absoluteUrl: {
      type: String,
      default: '',
    },
    acceptableCountiesFrom: {
      type: [Array, String],
      default: () => ([COUNTRY_CODES.RUSSIA]),
    },
    acceptableCountiesTo: {
      type: [Array, String],
      default: () => ([]),
    },
    countryFromDefault: {
      type: [String],
      default: null,
    },
    countryToDefault: {
      type: [String],
      default: null,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
    salePip: {
      type: Boolean,
      default: false,
    },
    hidePromocodeOption: {
      type: Boolean,
      default: false,
    },
    calcImport: {
      type: Boolean,
      default: false,
    },
    acceptableForcePromocode: {
      type: Boolean,
      default: false,
    },
    hideWarningBelarus: {
      type: Boolean,
      default: false,
    },
    hideFormEmail: {
      type: Boolean,
      default: false,
    },
    hideServices: {
      type: Boolean,
      default: false,
    },
    hideCourierWarning: {
      type: Boolean,
      default: false,
    },
    minPrice: {
      type: String,
      default: CALC_PIP.MIN_PRICE,
    },
    resultPage: {
      type: Boolean,
      default: false,
    },
    personalAgreementLink: {
      type: String,
      default: 'https://boxberry.ru/castnym-klientam/info-klientam/dokumenty',
    },
    luggageDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorDictionary,
      basePriceBeforePromoCode: null,
      packageSubmit: {
        type: null,
        package_id: null,
        name: null,
      },
      activeStep: 1,
      list_services: [],
      initialDeliveryOptions: [],
      isLoading: false,
      senderPointsCollection: [],
      receiverPointsCollection: [],
      kladr: {
        sender: '',
        receiver: '',
      },
      kladrChecked: {
        sender: '',
        receiver: '',
      },
      order_num: null,
      totalPrice: null,
      addressValid: {
        receiver: {
          val: '',
          confirm: false,
        },
        sender: {
          val: '',
          confirm: false,
        },
      },
      error: {
        modalShow: false,
        messageError: '',
      },
      warning: {
        modalShow: false,
        titleWarning: '',
        messageWarning: '',
        btnWarning: '',
      },

      orderCalcPIP: {
        sender: {
          city: false,
          cityName: '',
          region: '',
          country: '',
        },
        receiver: {
          city: false,
          cityName: '',
          region: '',
          country: '',
        },
        public_price: this.minPrice,
        package: {
          type: PACKAGE_TYPE.USER,
          package_id: false,
        },
        list_services: [],
        promo_code: null,
        height: null,
        width: null,
        depth: null,
        weight: null,
        return_point: '',
        forcePromocode: '',
        enableForcePromocode: '',
      },
      orderPIP: {
        dataCaptcha: null,
        delivery_type: null,
        payer_type: 1, // 1 = sender (default), 2 = receiver
        passport_type: 1, // 1 = rus (default), 2 = other
        public_price: this.minPrice, // при отправке *100
        package: {
          type: PACKAGE_TYPE.USER,
          package_id: false,
          attachment: '13',
        },
        list_services: [],
        promo_code: null,
        sender: {
          mask: '',
          maskRegexp: '',
          city: '',
          country: '',
          point: '',
          pointTitle: '',
          pointAddress: '',
          zip: '',
          name: '',
          document_type: 1,
          document_series: '',
          document_num: '',
          document_num_other: '',
          phone: '',
          email: '',
          address: '',
          addressStreet: '',
          addressHome: '',
          addressPorch: '',
          addressFlat: '',
          courierDetails: '',
          personal_agreement: false,
          addressPrivateHome: false,
          payment_agreement: false,
          document_agreement: false,
          acquiring: true,
          cashPayment: true,
          pointScheduleShort: '',
          pointPhone: '',
          pointPhotos: '',
        },
        receiver: {
          mask: '',
          maskRegexp: '',
          city: '',
          country: '',
          point: '',
          pointTitle: '',
          pointAddress: '',
          zip: '',
          name: '',
          phone: '',
          address: '',
          addressStreet: '',
          addressHome: '',
          addressPorch: '',
          addressFlat: '',
          courierDetails: '',
          addressPrivateHome: false,
          acquiring: true,
          cashPayment: true,
        },
        prepayd_sum: 0,
        themes: [],
      },
      defaultDeliveryType: null,
      isRestarted: false,
      needResetReceiverFields: false,
      needChangePointFrom: false,
      needChangePointTo: false,
      checkDeliveryMethod: {},
      paymentId: null,
      cbrDaily: [],
      items: [{
        descrExp: '',
        descrImp: '',
        manufacturer: '',
        quantity: '',
        price: '',
        priceExport: '',
        linkWeb: '',
      }],
      promocodeSubmitted: '',
      totalPriceImport: '',
      showCalcFixed: true,
      emailPayment: '',
      order: {
        payerType: '',
        price: '',
      },
      senderPointPayment: null,
      calcChanged: false,
      acceptReceiverPayments: false,
    };
  },
  computed: {
    ...deviceInfo,
    selectedDeliveryType() {
      return this.orderPIP.delivery_type ? this.orderPIP.delivery_type : this.defaultDeliveryType;
    },
    stepTitle() {
      switch (this.activeStep) {
        case 3:
          return (this.orderPIP.delivery_type === 1 || this.orderPIP.delivery_type === 2)
            ? 'Введите адрес отправителя' : this.$t('calc.titles.pvz_sender');
        case 4:
          return (this.orderPIP.delivery_type === 1 || this.orderPIP.delivery_type === 3)
            ? 'Введите адрес получателя' : this.$t('calc.titles.pvz_receiver');
        case 5:
          return this.$t('calc.titles.form');
        case 6:
          return this.calcImport ? 'Оплата' : this.$t('calc.titles.otpravlenie-sformirovano');
        case 7:
          return this.$t('calc.titles.otpravlenie-sformirovano');
        case 'form-customs':
          return 'Заполните данные о содержимом посылки';
        case 'pay-customs':
          return 'Создание посылки';
        default:
          return this.$t('calc.title');
      }
    },
    isValid() {
      return this.orderCalcPIP.sender.city
        && this.orderCalcPIP.sender.country
        && this.orderCalcPIP.receiver.city
        && this.orderCalcPIP.receiver.country
        && (this.orderPIP.package.type === PACKAGE_TYPE.USER ? this.validateSize : this.orderCalcPIP.package.package_id)
        && this.priceIsFine
        && !(this.calcImport && !this.weightIsFine)
        && !(this.calcImport && this.weightIsSmall);
    },
    maxPrice() {
      if (this.isDirectionKzKz) return CALC_PIP.MAX_PRICE_KZ_KZ;
      return (!this.orderCalcPIP.receiver.country || this.orderCalcPIP.receiver.country === COUNTRY_CODES.RUSSIA)
        ? '200 000'
        : '100 000';
    },
    minPriceResult() {
      if (this.isDirectionKzKz) return CALC_PIP.MIN_PRICE_KZ_KZ;
      return this.minPrice;
    },
    priceIsFine() {
      const productPrice = parseInt(replaceAll(replaceAll(this.orderCalcPIP.public_price, /^0+/g, ''), ' ', ''), 10);
      const maxPrice = parseInt(replaceAll(replaceAll(this.maxPrice, /^0+/g, ''), ' ', ''), 10);
      return productPrice >= this.minPriceResult && productPrice <= maxPrice;
    },
    weightIsFine() {
      return this.orderCalcPIP.weight && +this.orderCalcPIP.weight <= 15;
    },
    weightIsSmall() {
      return parseFloat(this.orderCalcPIP.weight) === 0;
    },
    boxSizeIsCorrect() {
      return (this.orderCalcPIP.height <= 120
      && this.orderCalcPIP.width <= 120
      && this.orderCalcPIP.depth <= 120);
    },
    boxSizeAnyIsCorrect() {
      const boxSize = [this.orderCalcPIP.height, this.orderCalcPIP.width, this.orderCalcPIP.depth].sort((a, b) => a - b);
      return boxSize[2] <= 120 && boxSize[1] <= 80 && boxSize[0] <= 50;
    },
    boxSizeSumIsCorrect() {
      return ((this.orderCalcPIP.height
        + this.orderCalcPIP.width
        + this.orderCalcPIP.depth) <= 250);
    },
    boxSizeIsZero() {
      return (this.orderCalcPIP.height === 0
        || this.orderCalcPIP.width === 0
        || this.orderCalcPIP.depth === 0);
    },
    boxSizeMinErrorBelarus() {
      const boxSize = [this.orderCalcPIP.height, this.orderCalcPIP.width, this.orderCalcPIP.depth].sort((a, b) => a - b);
      return (boxSize[0] !== null && boxSize[0] < 1) || (boxSize[2] !== null && boxSize[1] !== null && boxSize[1] < 10)
        || (boxSize[0] !== null && boxSize[1] !== null && boxSize[2] !== null && boxSize[2] < 10);
    },
    validateSize() {
      return this.orderCalcPIP.height
        && this.orderCalcPIP.width
        && this.orderCalcPIP.depth
        && this.boxSizeIsCorrect
        && this.boxSizeAnyIsCorrect
        && this.boxSizeSumIsCorrect
        && !(this.isSenderBelarus && this.boxSizeMinErrorBelarus);
    },
    // recipientDetailsOtherCountry() {
    //   return this.orderPIP.receiver.country !== COUNTRY_CODES.RUSSIA;
    // },
    hrefIM() {
      return this.$props.absoluteUrl ? `${this.$props.absoluteUrl}e-commerce#calculator` : '/e-commerce#calculator';
    },
    belarusWarning() {
      return this.isSenderBelarus;
    },
    isSenderBelarus() {
      return this.orderPIP.sender.country === COUNTRY_CODES.BELARUS;
    },
    russianWarning() {
      return this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA
        && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA
        && ![CITIES_CODES.MOSCOW, CITIES_CODES.SAINT_PETERSBURG].includes(this.orderPIP.sender.city);
    },
    showWarningVisa() {
      return this.orderPIP.sender.country
        && this.orderPIP.sender.country !== COUNTRY_CODES.RUSSIA
        && this.orderPIP.sender.country !== COUNTRY_CODES.ARMENIA;
    },
    showWarningArmenia() {
      return this.orderPIP.sender.country === COUNTRY_CODES.ARMENIA;
    },
    enableForcePromocode() {
      return this.acceptableForcePromocode
        && this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA
        && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA;
    },
    receiverCanPay() {
      return [COUNTRY_CODES.KAZAKHSTAN, COUNTRY_CODES.KYRGYZSTAN, COUNTRY_CODES.BELARUS, COUNTRY_CODES.ARMENIA]
        .includes(this.orderPIP.sender.country) && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA;
    },
    receiverPayImport() {
      return this.receiverCanPay && this.orderPIP.payer_type === '2';
    },
    isCustoms() {
      try {
        const countries = cityRepositoryGetters.countries();
        const countryReceiver = countries.find((item) => item.code === this.orderPIP.receiver.country);
        return !!(countryReceiver && countryReceiver.custom);
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    getStep() {
      if (this.activeStep === 1) return 1;
      if (this.activeStep === 2) return 2;
      if (this.activeStep === 'pay-customs') return 5;
      if (this.activeStep === 3) return 3;
      if (this.activeStep === 4) return 4;
      if (this.activeStep === 5) return 5;
      if (this.activeStep === 'form-customs') return 2;
      return 5;
    },
    isDirectionKzKz() {
      return this.orderPIP.sender.country === COUNTRY_CODES.KAZAKHSTAN && this.orderPIP.receiver.country === COUNTRY_CODES.KAZAKHSTAN;
    },
  },
  watch: {
    selectedDeliveryType() {
      this.orderPIP.delivery_type = this.selectedDeliveryType;
    },
    activeStep(newVal, oldVal) {
      if (newVal > oldVal) {
        this.isRestarted = false;
      }
      if (newVal && oldVal) {
        if (newVal !== 1 && newVal !== 2) {
          this.mobileScrollTop();
        }
        if (newVal !== 1 && newVal !== 2) {
          this.desktopScrollTop();
        }
        if (newVal === 2 && this.calcImport) {
          this.desktopScrollTop();
        }
      }
      if (newVal === 5) {
        this.getWarningText();
      }
      if ((this.activeStep === 6 && !this.calcImport) || this.activeStep === 7) {
        this.removeEventsListener();
      }
    },
    'orderCalcPIP.sender.country': function (val) {
      if (val) {
        this.$emit('senderChangeCountry', val);
      }
    },
    'orderCalcPIP.receiver.country': function (val, oldVal) {
      if (val && !oldVal && val === COUNTRY_CODES.KAZAKHSTAN && this.orderCalcPIP.sender.country === COUNTRY_CODES.KAZAKHSTAN) {
        this.orderCalcPIP.public_price = CALC_PIP.MIN_PRICE_KZ_KZ;
      }
    },
    'orderCalcPIP.sender.city': function (val, oldVal) {
      if (!oldVal && val && this.orderCalcPIP.receiver.city) {
        this.checkQueryPromocode();
        this.onSelectCitiesGoalYm();
        this.calcChanged = true;
      }
    },
    'orderCalcPIP.receiver.city': function (val, oldVal) {
      if (!oldVal && val && this.orderCalcPIP.sender.city) {
        this.checkQueryPromocode();
        this.onSelectCitiesGoalYm();
        this.calcChanged = true;
      }
    },
    'orderPIP.package.type': function (val) {
      this.orderCalcPIP.package.type = val;
    },
    calcImport(val) {
      if (val) {
        this.orderPIP.package.type = PACKAGE_TYPE.USER;
      }
    },
    enableForcePromocode(val) {
      if (!val) {
        this.orderCalcPIP.forcePromocode = '';
        this.orderCalcPIP.promo_code = '';
        this.orderPIP.promo_code = '';
      }
    },
  },
  beforeMount() {
    if (this.resultPage) {
      this.initResultPage();
    }
    if (this.calcImport) {
      this.orderPIP.passport_type = 2;
      this.orderPIP.package.type = PACKAGE_TYPE.USER;
      this.fetchCbrDaily();
    }
    cityRepositoryActions.load();
  },
  beforeDestroy() {
    this.removeEventsListener();
  },
  created() {
    this.COUNTRY_CODES = COUNTRY_CODES;
  },

  methods: {
    setNeedChangePointFrom(value) {
      this.needChangePointFrom = value;
    },
    setNeedChangePointTo(value) {
      this.needChangePointTo = value;
    },
    resetReceiverFields() {
      this.needResetReceiverFields = true;
    },
    mobileScrollTop() {
      const desktopHeader = document.querySelector('.header.header-desktop');
      let heightHeader = desktopHeader ? 110 : 100;
      const mobileStoreUpper = document.querySelector('.mobile-store-upper');
      if (mobileStoreUpper) {
        heightHeader += 50;
      }
      const heightScroll = $(this.$refs.calculatorPip).offset().top - heightHeader;

      if ($(window).width() <= 787) {
        window.scrollTo({
          top: heightScroll,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    desktopScrollTop() {
      const desktopHeader = document.querySelector('.header.header-desktop');
      const heightHeader = desktopHeader ? 180 : 100;
      const heightScroll = $(this.$refs.calculatorPip).offset().top - heightHeader;

      if ($(window).width() > 787) {
        window.scrollTo({
          top: heightScroll,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    checkFirstStep() {
      if (this.activeStep !== 1) {
        this.restart();
      }
    },
    getListOfServices() {
      const self = this;
      const url = this.$props.absoluteUrl ? `${this.$props.absoluteUrl}proxy/delivery/cost/pip?method=ListServices`
        : 'proxy/delivery/cost/pip?method=ListServices';
      axios.get(url, {
        // headers: { Authorization: odpApiToken },
      })
        .then((e) => {
          self.list_services = e.data.data;
        })
        .catch(() => {
          throw new Error('Ошибка в получении списка сервисов');
        });
    },
    getWarningText() {
      const url = this.$props.absoluteUrl ? `${this.$props.absoluteUrl}api/v1/country/info/${this.orderPIP.receiver.country}`
        : `api/v1/country/info/${this.orderPIP.receiver.country}`;
      const config = this.$props.absoluteUrl ? ({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }) : {};
      axios.get(url, config)
        .then((e) => {
          this.warning.titleWarning = e.data.title_modal_window;
          this.warning.messageWarning = e.data.text_modal_window;
          this.warning.btnWarning = e.data.text_modal_button;
        })
        .catch(() => {
          throw new Error('Ошибка в получении данных о стране');
        });
    },
    checkPoint(odp, person) {
      this.orderPIP[person].point = odp.id;
      this.thirdStepError = false;
      this.fourthStepError = false;
    },
    removeCheckPoint(person) {
      this.orderPIP[person].point = null;
      this.fourthStepError = true;
    },
    someAction() {
      this.$v.$touch();
    },
    onShowModalError(message) {
      if (message) {
        this.error.messageError = message;
      }
      this.error.modalShow = true;
    },
    onCloseModalError() {
      this.error.modalShow = false;
      this.error.messageError = '';
    },
    onCloseModalWarning() {
      this.warning.modalShow = false;
      this.warning.messageWarning = '';
      this.warning.btnWarning = '';
      this.activeStep = 6;
    },
    onFirstStepUp(deliveryOptions) {
      this.initialDeliveryOptions = deliveryOptions;
      if (!this.defaultDeliveryType && deliveryOptions.length) {
        this.defaultDeliveryType = deliveryOptions[0].delivery_type;
      }
      this.activeStep = 2;

      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step1');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step1' } }));

      this.fetchGoogleAnalytics('main_client_step2_CALC_CLICK_PM');

      this.$v.$reset();
    },
    onSecondStepUp(v) {
      this.senderPointsCollection = v.senderPointsCollection;
      this.receiverPointsCollection = v.receiverPointsCollection;

      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step2');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step2' } }));

      if (this.isCustoms) {
        this.activeStep = 'form-customs';
        return;
      }
      this.activeStep = 3;

      this.fetchGoogleAnalytics('main_client_step3_CALC_CLICK_PM');
    },
    onFormCustomsStepUp() {
      this.activeStep = 3;

      this.fetchGoogleAnalytics('main_client_step3_CALC_CLICK_PM');
    },
    onThirdStepUp() {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step3');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step3' } }));

      this.activeStep = 4;

      this.fetchGoogleAnalytics('main_client_step4_CALC_CLICK_PM');

      this.$v.$reset();
    },
    onFourthStepUp() {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step4');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step4' } }));

      this.activeStep = 5;

      this.fetchGoogleAnalytics('main_client_step5_CALC_CLICK_PM');

      this.$v.$reset();
    },
    onFifthStepUp(orderNumber) {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step5');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step5' } }));

      this.order_num = orderNumber;
      if (this.warning && this.warning.btnWarning && this.warning.messageWarning) {
        this.warning.modalShow = true;
      } else {
        this.activeStep = 6;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: this.order_num,
            },
            products: [{
              name: 'Заявка на доставку',
              price: this.totalPrice,
              quantity: 1,
            }],
          },
        },
        event: 'ecomm_main_client_calc_FORM_SENT_PM',
      });
      this.fetchGoogleAnalytics('main_client_calc_FORM_SENT_PM');
    },
    onFifthStepUpImport(orderInfo = {}) {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'pip_calc_step5_import');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'pip_calc_step5_import' } }));

      this.order_num = orderInfo.orderId;
      this.paymentId = orderInfo.id;
      if (this.warning && this.warning.btnWarning && this.warning.messageWarning) {
        this.warning.modalShow = true;
      } else {
        this.activeStep = 6;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: this.order_num,
            },
            products: [{
              name: 'Заявка на доставку',
              price: this.totalPrice,
              quantity: 1,
            }],
          },
        },
        event: 'ecomm_main_client_calc_FORM_SENT_PM',
      });
      this.fetchGoogleAnalytics('main_client_calc_FORM_SENT_PM');
    },
    onFifthStepUpCustoms() {
      this.activeStep = 'pay-customs';
    },
    onPayStepUp() {
      this.activeStep = 7;
    },
    onPayCustomsStepUp(orderNumber) {
      this.order_num = orderNumber;
      this.activeStep = 7;
    },
    onStepBack() {
      if (this.isCustoms && this.activeStep === 3) {
        this.activeStep = 'form-customs';
        return;
      }
      if (this.activeStep === 'form-customs') {
        this.activeStep = 2;
        return;
      }
      if (this.activeStep === 'pay-customs') {
        this.activeStep = 5;
        return;
      }
      if (this.activeStep > 1) {
        this.isRestarted = true;
        this.activeStep -= 1;
      }
    },
    onRestart($event) {
      this.restart($event);
    },
    restart(withScroll) {
      this.activeStep = 1;
      this.isRestarted = true;
      this.orderPIP.promo_code = '';
      this.orderCalcPIP.promo_code = '';
      this.orderCalcPIP.forcePromocode = '';
      if (withScroll) {
        this.desktopScrollTop();
      }
    },
    onCalcStepClick(toStep) {
      if (this.activeStep > toStep) {
        this.isRestarted = true;
        this.activeStep = toStep;
      }
    },
    onChangeTotalPrice(totalPrice) {
      this.totalPrice = totalPrice;
    },
    onChangeCheckDeliveryMethod(checkDeliveryMethod) {
      this.checkDeliveryMethod = checkDeliveryMethod;
    },
    onSelectCitiesGoalYm() {
      if (typeof ym !== 'undefined') {
        ym(57872296, 'reachGoal', 'cities_selected');
      }
      document.dispatchEvent(new CustomEvent('reachGoal', { detail: { targetName: 'cities_selected' } }));
    },
    fetchCbrDaily() {
      const url = `${NEW_API_URL}/cbr/daily`;

      axios.get(url)
        .then((resp) => {
          if (!resp.data || !resp.data.length) {
            throw new Error('нет стоимости');
          }
          const cbrDaily = resp.data;
          const BelarusDailyIndex = cbrDaily.findIndex((item) => item.numeric_code === '933');
          if (BelarusDailyIndex !== -1) {
            cbrDaily[BelarusDailyIndex] = { ...cbrDaily[BelarusDailyIndex], numeric_code: COUNTRY_CODES.BELARUS.toString() };
          }
          this.cbrDaily = cbrDaily;
        })
        .catch((e) => {
          console.error(e);
          this.cbrDaily = [];
        });
    },
    fetchGoogleAnalytics(event) {
      if (window.location.host.indexOf('boxberry.ru') === -1) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event,
      });
    },
    checkQueryPromocode() {
      const searchParams = new URLSearchParams(window.location.search);
      const promocode = searchParams.get('promocode');
      if (!promocode) return;
      const promocodeText = promocode.replaceAll('<', '').replaceAll('>', '');
      this.orderCalcPIP.promo_code = promocodeText;
      this.orderPIP.promo_code = promocodeText;
    },
    onBtnNextClick() {
      if (this.activeStep === 2) {
        this.$refs.calculatorPip2ndStep.secondCalcStepHandlerPIP();
      }
    },
    onChangeOrder(order) {
      this.order.price = order?.data?.price || null;
      // eslint-disable-next-line
      this.order.payerType = order?.data?.payer_type || null;
    },
    onChangeEmail(email) {
      this.emailPayment = email;
    },
    initResultPage() {
      this.activeStep = 7;
      this.order_num = window.location.pathname.replace('/success/', '').replace('/fail/', '');
      const params = new URLSearchParams(window.location.search);
      if (params.has('point_code')) {
        const pointOdp = params.get('point_code');
        axios.get(`${NEW_API_URL}/odp/${pointOdp}`)
          .then((resp) => {
            this.senderPointPayment = resp.data;
            this.orderPIP.sender.point = resp.data.id;
          })
          .catch(() => {

          });
      }
    },
    onChangedReceiverPoints(receiverPoints) {
      this.receiverPointsCollection = receiverPoints;
    },
    onChangedAcceptReceiverPayments(acceptReceiverPayments) {
      this.acceptReceiverPayments = acceptReceiverPayments;
    },
  },
  validations: {
    // Название поля должно совпадать с полем в data
    orderPIP: {
      receiver: {
        phone: {
          required,
          validPhone: (val, vm) => vm.maskRegexp.test(val),
        },
        name: {
          required,
          validName(val) {
            const regExp = this.calcImport ? /^\D+\s\D+$/ : /^\D+$/;
            return regExp.test(val);
          },
          validNameLatin(val) {
            const regExp = /^[a-z ,.'-]+$/i;
            return !this.isCustoms || regExp.test(val);
          },
        },
        point: {
          required,
        },
        addressStreet: {
          required,
        },
        addressHome: {
          required,
        },
        addressPorch: {
          required,
        },
      },
      sender: {
        personal_agreement: {
          sameAs: sameAs(() => true),
        },
        document_num: {
          required,
          minLength: minLength(8),
        },
        document_num_other: {
          required,
          minLength: minLength(3),
        },
        document_series: {
          required,
          minLength: minLength(5),
        },
        point: {
          required,
        },
        document_agreement: {
          sameAs: sameAs(() => true),
        },
        name: {
          required,
          validName(val) {
            const regExp = this.calcImport ? /^\D+\s\D+$/ : /^\D+$/;
            return regExp.test(val);
          },
          validNameLatin(val) {
            const regExp = /^[a-z ,.'-]+$/i;
            return !this.isCustoms || regExp.test(val);
          },
        },
        phone: {
          required,
          validPhone: (val, vm) => vm.maskRegexp.test(val),
        },
        email: {
          required,
          // eslint-disable-next-line max-len
          validFormat: (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val),
        },
        address: {
          required,
        },
        addressStreet: {
          required,
        },
        addressHome: {
          required,
        },
        payment_agreement: {
          sameAs: sameAs(() => true),
        },
      },
      themes: {
        validThemes(val) {
          return !this.calcImport || !!(val && val.length);
        },
      },
    },
    emailPayment: {
      required,
      // eslint-disable-next-line max-len
      validFormat: (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val),
    },
  },
};
</script>

<style lang="scss">
  .calculator {
    @import './CalculatorPIPView.scss';
    @import '../style/fields.scss';
  }
</style>
